import { useState } from "react";
import "./LoginModal.css";
import { BACKEND_LINK } from "./App";
import LoginForm from "./components/LoginForm";
import RegisterForm from "./components/RegisterForm";
import ForgotPasswordForm from "./components/ForgotPasswordForm";
import WarningMessage from "./components/WarningMessage";
import FormButtons from "./components/FormButtons";
import FormFooter from "./components/FormFooter";

function LoginModal({ isOpen, onClose, refetch }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");

  const [email, setEmail] = useState("");
  const [registering, setRegistering] = useState(false);
  const [wrong, setWrong] = useState(false);
  const [loginMessage, setLoginMessage] = useState("");
  const [registerMessage, setRegisterMessage] = useState("");

  const [forgotPassword, setForgotPassword] = useState(false);
  const [forgotStep, setForgotStep] = useState(1);
  const [forgotEmail, setForgotEmail] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [forgotModalPassword, setForgotModalPassword] = useState("");
  const [forgotModalPasswordConfirm, setForgotModalPasswordConfirm] = useState("");
  const [forgotMessage, setForgotMessage] = useState("");
  const [forgotWrong, setForgotWrong] = useState(false);

  if (!isOpen) return null;

  const handleLogin = (e) => {
    e.preventDefault();
    fetch(BACKEND_LINK + "/login", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            login: username,
            password: password
        }),
        credentials: "include"
        }).then(async (response) => {
            setPassword("");
            if(response.ok) {
              setWrong(false);
              setLoginMessage("");
              setUsername("")
              refetch();
              onClose();
            }
            else {
                try {
                  const json = await response.json();
                  setLoginMessage(json.message || "Username/email and password do not match.");
                } catch {
                  setLoginMessage("Username/email and password do not match.");
                }
                setWrong(true);
            }
        }).catch(() => {});
  };

  const handleRegister = (e) => {
    e.preventDefault();
    if (password != passwordConfirm) {
      setWrong(true);
      setRegisterMessage("Password confirmation is not the same as password.")
      return;
    }
    fetch(BACKEND_LINK + "/register", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          username: username,
          password: password,
        }),
        credentials: "include"
        }).then(async (response) => {
            if(response.ok) {
              switchMode();
            }
            else {
                const json = await response.json();
                setRegisterMessage(json.message);
                setWrong(true);
            }
        }).catch(() => {});;
  };
  const switchMode = () => {
    setRegistering(!registering);
    setWrong(false);
    setLoginMessage("");
  }

  const clearForgotPasswordState = () => {
    setForgotPassword(false);
    setForgotStep(1);
    setForgotEmail("");
    setVerificationCode("");
    setForgotModalPassword("");
    setForgotModalPasswordConfirm("");
    setForgotMessage("");
    setForgotWrong(false);
  };

  const askPasswordReset = async () => {
    const retval = await fetch(BACKEND_LINK + "/password-reset-token", {
        method: "PATCH",
        body: forgotEmail,
      }).then( response => {
        return response.ok;
      });
    return retval;
  }

  const tryPasswordReset = async () => {
    try {
      const response = await fetch(BACKEND_LINK + "/password-reset", {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: forgotEmail,
          password: forgotModalPassword,
          token: verificationCode
        })
      });
      
      const data = await response.text();
      
      if (!response.ok) {
        setForgotWrong(true);
        setForgotMessage(data || "An error occurred");
        return false;
      } else {
        setForgotWrong(false);
        setForgotMessage("");
        return true;
      }
    } catch (error) {
      setForgotWrong(true);
      setForgotMessage("Network error: " + error.message);
      return false;
    }
  }

  const handleForgotPasswordNext = async () => {
    switch (forgotStep) {
      case 1:
        const generated = await askPasswordReset();
        if (generated) {
          setForgotStep(forgotStep + 1); 
          setForgotWrong(false);
          setForgotMessage("")
        } else {
          setForgotWrong(true);
          setForgotMessage("Error has occured, please try again later.");
        }
        break;
      case 2:
        setForgotStep(forgotStep + 1);
        break;
      case 3:
        if (forgotModalPassword != forgotModalPasswordConfirm) {
          setForgotWrong(true);
          setForgotMessage("The password confirmation does not match the new password.");
          break;
        }
        const reset = await tryPasswordReset();
        if (reset) {
          setForgotStep(forgotStep + 1);
          setForgotWrong(false);
          setForgotMessage("");
        }
        break;
      case 4:
        clearForgotPasswordState();
        break;
    }
  };

   return (
    <div className="form-container">
      {
        forgotPassword ? <p className="title-login">Reset Password</p> :
        registering ? <p className="title-login">Register</p> : <p className="title-login">Login</p>
      }
      <WarningMessage message={forgotPassword ? (forgotWrong ? forgotMessage : "") : (registering ? registerMessage : (wrong ? loginMessage : ""))} />
      <form className="form">
        {
          forgotPassword ? 
          <ForgotPasswordForm
            forgotStep={forgotStep}
            forgotEmail={forgotEmail}
            setForgotEmail={setForgotEmail}
            verificationCode={verificationCode}
            setVerificationCode={setVerificationCode}
            password={forgotModalPassword}
            setPassword={setForgotModalPassword}
            passwordConfirm={forgotModalPasswordConfirm}
            setPasswordConfirm={setForgotModalPasswordConfirm}
            handleForgotPasswordNext={handleForgotPasswordNext}
            onCancel={clearForgotPasswordState}
            forgotMessage={forgotMessage}
            setForgotMessage={setForgotMessage}
            forgotWrong={forgotWrong}
            setForgotWrong={setForgotWrong}
          />
          :
          <>
            {
              registering ? 
              <RegisterForm 
                email={email} 
                setEmail={setEmail} 
                username={username} 
                setUsername={setUsername}
                password={password}
                setPassword={setPassword}
                passwordConfirm={passwordConfirm}
                setPasswordConfirm={setPasswordConfirm}
              />
              :
              <LoginForm 
                username={username} 
                setUsername={setUsername}
                password={password}
                setPassword={setPassword}
                onForgotPassword={() => setForgotPassword(true)}
              />
            }
            <FormButtons
              registering={registering}
              submitLabel={registering ? "Register" : "Sign in"}
              onSubmit={registering ? handleRegister : handleLogin}
              onCancel={() => {setWrong(false); setLoginMessage(""); onClose();}}
            />
          </>
        }
      </form>

      {forgotPassword ? null : <FormFooter registering={registering} onSwitchMode={switchMode} />}
    </div>
  );
}

export default LoginModal;
